export const DelphiUserId = 1;
export const DelphiCompanyId = 1;
export const DelphiGroupId = 0;
